/**
 * @author       justin.jeong@zumper.com (Justin Jeong)
 * @copyright    Copyright (c) 2019, Zumper
 * @description  PriceChart constants index
 */

// fetching
export const DONE_FETCHING_CITY_PRICE_CHART_DATA =
  '@@nzr/priceChart/locale/DONE_FETCHING_CITY_PRICE_CHART_DATA'
export const DONE_FETCHING_HOOD_PRICE_CHART_DATA =
  '@@nzr/priceChart/locale/DONE_FETCHING_HOOD_PRICE_CHART_DATA'
export const ERROR_FETCHING_CITY_PRICE_CHART_DATA =
  '@@nzr/priceChart/locale/ERROR_FETCHING_CITY_PRICE_CHART_DATA'

export const ERROR_FETCHING_HOOD_PRICE_CHART_DATA =
  '@@nzr/priceChart/locale/ERROR_FETCHING_HOOD_PRICE_CHART_DATA'
export const START_FETCHING_CITY_PRICE_CHART_DATA =
  '@@nzr/priceChart/locale/START_FETCHING_CITY_PRICE_CHART_DATA'
export const START_FETCHING_HOOD_PRICE_CHART_DATA =
  '@@nzr/priceChart/locale/START_FETCHING_HOOD_PRICE_CHART_DATA'

// storing
export const CLEAR_PRICE_CHART_DATA = '@@nzr/priceChart/locale/CLEAR_PRICE_CHART_DATA'
export const CLEAR_HOOD_PRICE_CHART_DATA = '@@nzr/priceChart/locale/CLEAR_HOOD_PRICE_CHART_DATA'
export const SET_CITY_PRICE_CHART_DATA = '@@nzr/priceChart/locale/SET_CITY_PRICE_CHART_DATA'
export const SET_HOOD_PRICE_CHART_DATA = '@@nzr/priceChart/locale/SET_HOOD_PRICE_CHART_DATA'
